<template>
  <div class="distributionCenter">
    <!-- <heads></heads> -->
    <div class="container" v-if="isshow">
      <div class="content">
        <div class="list">
          <div class="useractivity">
            <div class="useritem" v-for="(item,index) in kindList" :key="index">
              <div class="img">
                <img :src="item.picture.linePicture" class="act-img" />
              </div>
              <div class="user-right">
                <div class="toporder">
                  <span class="order">订单号：{{item.orderSale.sn}}</span>
                  <span class="complete">{{parseInt(item.orderSale.orderStatus) ? '已确认' : '未确认'}}</span>
                </div>
                <div class="act-title">{{item.orderSale.lineOrder.lineSchedule.line.lineTitile}}</div>
                <div class="toporder">
                  <span class="orderprice">
                    <span class="red">￥{{item.orderSale.orderTotalSum}}</span>
                    <!-- <span class="mount">X1</span> -->
                  </span>
                  <span class="date">{{fomateDate(item.orderSale.createDate)}}</span>
                </div>
                <!-- <p class="userdescribe">想要躲避都市的喧嚣？想享尽情吸氧？想寻幽探秘、玩赏奇特美景？想来点不一样的，玩转无聊假期？今天给你的推挤都能满足</p> -->
                <div class="bottom-infos">
                  <div>
                    <!-- <span class="icon-one">付款金额：￥136</span> -->
                    <span class="icon-two">佣金：￥{{item.orderSale.money}}</span>
                  </div>
                  <span class="mores" @click="todeatl(item.orderSale.id)">查看</span>
                </div>
              </div>
            </div>
          </div>
           <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :page-size="distribution.pageSize"
                :total="distribution.total"
              ></el-pagination>
            </div>
        </div>
      </div>
    </div>
    <!-- <distributionDetail v-if="!isshow" /> -->
    <!-- <homeFoots></homeFoots> -->
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import distributionDetail from "@/components/userview/distributionDetail";
import axios from "axios";
import {fomateDate} from "@/util/util.js";

export default {
  name: "distributionCenter",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      isshow: true,

      distribution:{
        total:0,
        currentPage: 1,
        pageSize: 10,
        list:[]
      }
    };
  },
  components: {
    distributionDetail
    // heads,
    // homeFoots,
    // banners
  },
  computed: {
    // nav() {
    //   return this.$route.params.id;
    // }
    kindList(){
      return this.distribution.list[this.distribution.currentPage -1];
    }
  },
  methods: {
    fomateDate,

    todeatl(id) {
      this.$router.push({
        path: `/userindex/8`,
        query: { id }
      });
    //   this.$router.push({ path: `/userindex/8` });
    },
    getNav(index) {
      this.nav = index;
    },
    handleCurrentChange(val) {
      this.distribution.currentPage = val;
      const pageSize = this.distribution.pageSize;
      const list = this.distribution.list;

      this.getDistributionCenter(val,pageSize).then(res => {
        this.distribution.total = res.data.total;

        if(res.data.success && res.data.output.list){
          for(let i = 1; i < val ; i++){ //填充空元素
            if(!list[i]){
              list.push(1);
            }
          }
          list.splice(val - 1,val,res.data.list);
        }
      })
    },
    getDistributionCenter(pageNumber,pageSize){
      return axios.get('/mobile/wallet/shareList.jhtml',{
        params:{
          pageNumber,
          pageSize
        }
      })
    }
  },
  mounted() {},
  created() {
    this.getDistributionCenter(1,10).then(res => {
      if(res.data.success){
        this.distribution.total = res.data.output.total;
        this.distribution.list.push(res.data.output.content);
      }
    });
  }
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
}
.content {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-between; */
}
.list {
  cursor: pointer;
  width: 100%;
  padding: 20px;
  /* box-shadow: 0px 0px 6px #c7c6c6;
      border-radius: 2px; */
  margin-bottom: 20px;
}
.orderprice {
}
.red {
  display: inline-block;
  margin-right: 10px;
  color: #e73835;
}
.mount {
  font-size: 12px;
}
.date {
  color: #999999;
}
.evaluate {
  display: flex;
}
.evaluate > span {
  font-size: 15px;
  width: 80px;
  color: #666666;
  line-height: 20px;
}
.evaluate > span:nth-child(2) {
  text-align: right;
  border-left: 1px solid #999999;
}

.useractivity {
  width: 100%;

  min-height: 300px;
}
.useritem {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px #c7c6c6;
  margin-bottom: 16px;
}
.img {
  position: relative;
  width: 24%;
  height: 180px;
}
.act-img {
  width: 100%;
  height: 100%;
}
.user-price {
  position: absolute;
  z-index: 30;
  bottom: 14px;
  right: 16px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  padding: 4px 12px;
}
.user-right {
  width: 76%;
  position: relative;
  padding: 20px;
  /* box-sizing: border-box; */
}
.toporder {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order {
  color: #666666;
}
.complete {
  color: #007741;
  border: 1px solid #007741;
  font-size: 14px;
  border-radius: 16px;
  padding: 4px 12px;
}
.act-title {
  font-weight: bold;
  margin: 16px 0;
}
.userdescribe {
  margin-top: 20px;
  line-height: 24px;
  color: #999999;
}
.bottom-infos {
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 10px;
}
.icon-one {
  color: #323232;
  margin-right: 10px;
}
.icon-two {
  color: #323232;
}
.mores {
  border-radius: 6px;
  padding: 4px 20px;
  color: #ffffff;
  background: #007741;
}
.mores:hover{
     background: #069e5a; 

}
</style>



// WEBPACK FOOTER //
// src/components/userview/distributionCenter.vue